export function reviewNoun(reviewCount: number) {
    return reviewCount === 1 ? "review" : "reviews";
}

export function reviewsLine(reviewCount: number): string | null {
    if (reviewCount === 0) return null;
    return `${reviewCount} ${reviewNoun(reviewCount)}`;
}
